import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0708ab5c&scoped=true&lang=pug&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0708ab5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708ab5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
